export default __webpack_public_path__ + "981cb4fc9d36cf052d44b09573b3afee.svg";